import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body pb-0 px-0" }
const _hoisted_2 = { class: "d-flex flex-stack px-9" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-dark mb-1 fs-2 fw-boldest" }, "แนวโน้มยอดขาย"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600 fw-bold mt-2 fs-6" }, "ยอดขายรายเดือน This Year")
], -1)
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-circle btn-icon btn-active-light",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack px-9 mt-5\"><div class=\"row\"><div class=\"col-12\"><span style=\"color:grey;font-size:28px;\">฿</span><span style=\"font-size:30px;\"> 14,094,700 </span><button style=\"padding:5px;\" class=\"btn btn-sm btn-light-success mb-3 fw-boldest\"><i class=\"bi bi-arrow-up\"></i>2.2% </button></div><div class=\"col-12\"><div class=\"col fs-5\" style=\"color:grey;\"> Total Sales This Year </div></div></div></div>", 1)
const _hoisted_8 = { class: "tab-content pt-8" }
const _hoisted_9 = {
  class: "tab-pane fade active show",
  id: "kt_charts_widget_3_tab_pane_1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen023.svg" })
            ])
          ])
        ])
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_apexchart, {
            class: "card-rounded-bottom h-125px",
            type: "area",
            height: "264",
            options: _ctx.chartOptions,
            series: _ctx.series
          }, null, 8, ["options", "series"])
        ])
      ])
    ])
  ], 2))
}